import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import { FormHelperText, Grid, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import Table from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import { default as CustomSelect } from "../../../components/Select/Select";
import {
  enableCheckoutByAppointmentId,
  getClinicPaymentsByFilter,
  getClinicPaymentsForSuggestion,
  updatePayment,
} from "../../../redux/reducers/clinicSlice";
import { getPaymentMethods } from "../../../redux/reducers/paymentMethodSlice";
import { updateReturnOnBillingItems } from "../../../redux/reducers/paymentSlice";
import { AppColors } from "../../../util/AppColors";
import {
  PaymentTypeList,
  RefundTypes,
  paymentInvoiceTypeList,
  paymentSourceTypes,
  paymentStatusList,
  returnReasons,
} from "../../../util/dropList";
import { paymentKeyword } from "../../../util/enum";
import {
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getRefundValues,
  getRightSaluation,
  getTaxAndSubTotalAndTotal,
  getTreatmentRecordBasedType,
  roundWithSignedDiff,
} from "../../../util/function";
import { baseURL } from "../../../util/server";
import CommonPayModal from "../../CommonComponents/CommonPayModal";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";
import BillingPreview from "../../CommonScreens/BillingPreview/BillingPreview";
import "./ClinicPayments.css";
import CollectionsTable from "./CollectionsTable";

const tableHeaders = [
  "petName",
  "vetName",
  "totalDue",
  "balanceDue",
  "payType",
  "paymentStatus",
  "trDate",
  "pay",
];
const pendingTableHeaders = [
  "petName",
  "vetName",
  "totalDue",
  "balanceDue",
  "payType",
  // "paymentStatus",
  "trDate",
  "pay",
];

const initialValues = { amount: "", paymentMode: null };

const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const initSearch = {
  petName: "",
  userName: "",
  vetName: "",
  // startDate: null,
  // endDate: null,
  status: [],
  // type: [],
  source: [],
};
const filterByList = [
  "Transaction Date",
  "Invoice Number",
  // "Status",
  // "Type",
  "Invoice Type",
  "Payment Mode",
  "Total Due",
  "Balance Due",
  "Person In Charge",
];
const dropFields = [
  // "Status",
  // "Type",
  "Invoice Type",
  "Payment Mode",
  "Person In Charge",
];
const splitRows = ["Transaction Date", "Total Due", , "Balance Due"];

const Payments = ({
  posPayId,
  setPosPayId,
  setPaymentTableType,
  paymentTableType,
  setSelectedPaymentTab,
  selectedPaymentTab,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tablePayments, setTablePayments] = useState([]);
  const [payValues, setPayValues] = useState(initialValues);
  const [payErr, setPayErr] = useState({});
  const [searchText, setSearchText] = useState("");
  const [payModalVisible, setPayModalVisible] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const [selectMode, setSelectMode] = useState("all");
  const [selectedSource, setSelectedSource] = useState("all");
  const [modalData, setModalData] = useState(null);
  const [page, setPage] = useState(1);
  const [selectedBill, setSelectedBill] = useState(null);
  const [invModVisible, setInvModVisible] = useState(false);
  const [returnModVsble, setReturnModVsble] = useState(false);
  const [returnValue, setReturnValue] = useState({});
  const [listNotValid, setListNotValid] = useState(false);
  const [enabledPaymentTypes, setEnabledPaymentTypes] =
    useState(PaymentTypeList);
  const [totalBalanceDue, setTotalBalanceDue] = useState(0);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [filterValues, setFilterValues] = useState(initFilter);
  const {
    payments,
    hugePayments,
    // details: clinicDet,
    clinicStocks: stocks,
    paymentsByFilter,
    paymentsForSuggestion,
  } = useSelector((state) => state?.clinic);
  const lastSummary = useSelector((state) => state?.pet?.lastSummary?.data);
  const paymentMethod = useSelector((state) => state?.paymentMethod);
  // const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const itemsPerLoad = 10;
  const hugeRecordSize = 50;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { clinic: clinicDet, vets: clinicVets } = useMemo(() => {
    if (!mandateDataRaw) {
      return { clinic: {}, vets: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
      };
    } catch {
      return { clinic: {}, vets: [] };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    // Reset filter values to initial state when component mounts
    setFilterValues({ ...initFilter, selectedList: [], values: {} });
    dispatch(getClinicPaymentsForSuggestion({ itemSize: 200, page: 1 }));
    // dispatch(getClinicStocks());
    // dispatch(getServices());
    dispatch(getPaymentMethods());
    // dispatch(getClinicVets("?type=all"));
  }, []);

  //for set the search value, data will comes from Billing dashboard
  useEffect(() => {
    if (
      // paymentTableType === "today" ||
      paymentTableType === "unpaid" &&
      selectedPaymentTab === "Finalized"
    ) {
      // if (paymentTableType === "today") {
      //   const reqObj = {
      //     ...filterValues,
      //     selectedList: [
      //       ...(filterValues?.selectedList ?? []),
      //       "Transaction Date",
      //     ],
      //     values: {
      //       ...(filterValues?.values ?? {}),
      //       "Start Date": new Date(),
      //       "End Date": new Date(),
      //     },
      //   };
      //   setFilterValues(reqObj);
      //   onPaymentsApiCall(1, false, null, reqObj);
      //   setPaymentTableType(null);
      // }
      if (paymentTableType === "unpaid") {
        const reqObj = {
          ...searchValues,
          status: [
            { name: "Unpaid", value: "unpaid" },
            { name: "Partially Paid", value: "ppaid" },
          ],
        };
        setSearchValues(reqObj);
        onPaymentsApiCall(1, false, reqObj);
        setPaymentTableType(null);
      }
    }
  }, [paymentTableType, selectedPaymentTab]);

  useEffect(() => {
    if (!paymentTableType) {
      onPaymentsApiCall(1);
    }
  }, [
    searchValues?.petName,
    searchValues?.userName,
    searchValues?.vetName,
    searchValues?.status,
    // searchValues?.type,
    searchValues?.source,
    paymentTableType,
  ]);

  const getFilterObj = (
    currentPage = 1,
    reset = false,
    searchObj = null,
    filterObj = null,
    tab = "Pending",
  ) => {
    setPage(currentPage);
    const reqTab = tab ?? selectedPaymentTab;
    const reqObj = {
      page: currentPage,
      itemSize: itemsPerLoad,
      checkOut: reqTab === "Finalized" ? ["Y", "P"] : ["N"],
    };
    const srchValues = searchObj ?? searchValues;
    const filValues = filterObj ?? filterValues;
    if (reset) return reqObj;
    if (srchValues?.petName?.length > 0) reqObj.petName = srchValues?.petName;
    if (srchValues?.userName?.length > 0)
      reqObj.username = srchValues?.userName;
    if (srchValues?.vetName?.length > 0) reqObj.vetName = srchValues?.vetName;
    if (srchValues?.status?.length > 0) {
      reqObj.status = (srchValues?.status ?? [])?.some(
        (li) => li?.value === "all",
      )
        ? ["paid", "unpaid", "ppaid", "partiallypaid"]
        : (srchValues?.status ?? [])?.map((li) => paymentKeyword?.[li?.value]);
    }
    if ((srchValues?.source ?? [])?.length > 0) {
      reqObj.type = (srchValues?.source ?? [])?.some(
        (li) => li?.value?.toLowerCase() === "all",
      )
        ? ["Clinic", "Pharmacy", "Pet Shop"]
        : (srchValues?.source ?? [])?.map((li) => li?.value);
    }
    // if ((srchValues?.type ?? [])?.length > 0) {
    //   reqObj.type = (srchValues?.type ?? [])?.map((li) => li?.value);
    // }
    if (filValues?.selectedList?.includes("Transaction Date")) {
      reqObj.startDate = moment(
        new Date(new Date(filValues?.values?.["Start Date"] ?? new Date())),
      ).format("YYYY-MM-DD");
    }
    if (filValues?.values?.["End Date"]) {
      reqObj.endDate = moment(
        new Date(new Date(filValues?.values?.["End Date"] ?? new Date())),
      ).format("YYYY-MM-DD");
    }
    if (
      filValues?.selectedList?.includes("Invoice Number") &&
      filValues?.values?.["Invoice Number"]?.length > 0
    ) {
      reqObj.invoiceNumber = filValues?.values?.["Invoice Number"];
    }
    if (filValues?.selectedList?.includes("Total Due")) {
      reqObj.totalDueMin = Number(filValues?.values?.["Min Total Due"] ?? 0);
      reqObj.totalDueMax = Number(filValues?.values?.["Max Total Due"] ?? 0);
    }
    if (filValues?.selectedList?.includes("Balance Due")) {
      reqObj.balanceDueMin = Number(
        filValues?.values?.["Min Balance Due"] ?? 0,
      );
      reqObj.balanceDueMax = Number(
        filValues?.values?.["Max Balance Due"] ?? 0,
      );
    }
    if (
      filValues?.selectedList?.includes("Invoice Type") &&
      filValues?.values?.["Invoice Type"]?.length > 0
    ) {
      reqObj.invoiceType = filValues?.values?.["Invoice Type"]?.map(
        (li) => li?.value,
      );
    }
    if (
      filValues?.selectedList?.includes("Payment Mode") &&
      filValues?.values?.["Payment Mode"]?.length > 0
    ) {
      reqObj.paymentMode = filValues?.values?.["Payment Mode"]?.map(
        (li) => li?.value,
      );
    }
    if (
      filValues?.selectedList?.includes("Person In Charge") &&
      filValues?.values?.["Person In Charge"]
    ) {
      reqObj.personInCharge = filValues?.values?.["Person In Charge"];
    }
    return reqObj;
  };

  const onPaymentsApiCall = (
    currentPage = 1,
    reset = false,
    searchObj = null,
    filterObj = null,
    tab = null,
  ) => {
    dispatch(
      getClinicPaymentsByFilter(
        getFilterObj(currentPage, reset, searchObj, filterObj, tab),
      ),
    );
  };

  const getSuggestionList = () => {
    const reqList =
      paymentsForSuggestion?.data
        ?.flatMap((obj) => [
          obj.petShopInvoiceNumber ?? "",
          obj.treatmentInvoiceNumber ?? "",
          obj.invoiceNumbers ?? "",
        ])
        ?.filter(Boolean) ?? [];
    const uniqList = uniq(reqList ?? []);
    return uniqList ?? [];
  };

  const createModalOpen = (li, balDue) => {
    setModalData(li);
    setTotalBalanceDue(balDue);
    if (li?.advanceAmount && Number(li?.advanceAmount) <= 0) {
      const filtered = PaymentTypeList.filter(
        (list) => list?.value !== "advanceAdjustment",
      );
      setEnabledPaymentTypes(filtered);
    } else {
      setEnabledPaymentTypes(PaymentTypeList);
    }
    setPayValues({ ...payValues, amount: balDue });
    setPayModalVisible(true);
  };

  const filterPayments = (payments, searchText) => {
    if (!searchText) return payments;

    return payments?.filter((payment) => {
      const petNameMatch = payment?.petName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const vetNameMatch = payment?.doctorName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const userNameMatch = payment?.userName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const userEmailMatch = payment?.email
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const userMobileMatch = payment?.mobile
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const paymentStatusMatch = payment?.status
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      return (
        petNameMatch ||
        vetNameMatch ||
        paymentStatusMatch ||
        userNameMatch ||
        userEmailMatch ||
        userMobileMatch
      );
    });
  };

  const handleChangeValues = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    setPayValues({ ...payValues, [name]: value });
    const errObj = {
      ...payErr,
      [name]: reqValue?.length > 0 ? "" : "This field is required",
    };
    if (name === "paymentMode") {
      if (reqValue !== "advanceAdjustment") {
        errObj.amount = "";
      }
      if (reqValue === "advanceAdjustment") {
        if (Number(modalData?.advanceAmount ?? 0) <= 0) {
          errObj.amount = "Insufficient credit balance";
        }
      }
    }
    if (name === "amount") {
      if (payValues?.paymentMode?.value === "advanceAdjustment") {
        errObj.amount =
          Number(value) < 0
            ? "Amount must be positive"
            : Number(value) > Number(modalData?.advanceAmount)
              ? "Insufficient credit balance"
              : "";
      } else {
        errObj.amount = Number(value) < 0 ? "Amount must be positive" : "";
      }
      if (Number(value) > totalBalanceDue) {
        errObj.amount = "Amount must be less than or equal to balance due";
      }
    }
    setPayErr(errObj);
  };

  const handleReturns = (bill) => {
    const reqObj = {
      personInCharge: null,
      returnReason: returnReasons?.[0],
      refundMethod: { name: "Advance Adjustment", value: "advanceAdjustment" },
      // list: bill?.paymentDetails
      //   ?.filter(
      //     (li) =>
      //       li?.credit === "N" &&
      //       li?.type?.toLowerCase() !== "consumables" &&
      //       li?.type?.toLowerCase() !== "administered" &&
      //       li?.quantity > 0 &&
      //       (li?.returnQuantity === 0 || !li?.returnQuantity),
      //   )
      //   ?.map((li) => ({
      //     ...li,
      //     returnQuantity: 0,
      //   })),
    };
    if (
      bill?.invoiceNumbers?.length > 0 ||
      bill?.treatmentInvoiceNumber?.length > 0 ||
      bill?.petShopInvoiceNumber?.length > 0
    ) {
      reqObj.selectedInvoiceNumber =
        bill?.invoiceNumbers?.length > 0
          ? bill?.invoiceNumbers
          : bill?.treatmentInvoiceNumber?.length > 0
            ? bill?.treatmentInvoiceNumber
            : bill?.petShopInvoiceNumber?.length > 0
              ? bill?.petShopInvoiceNumber
              : "";
    }
    setReturnValue(reqObj);
    setSelectedBill(bill);
    setReturnModVsble(true);
  };

  const getPersonInChargeList = () => {
    return (clinicVets ?? [])
      ?.filter(
        (li) =>
          li?.userRole === "ROLE_CLINICADMIN" ||
          li?.userRole === "ROLE_BILLING",
      )
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
  };

  const onClickView = (pay, totalAmt) => {
    if (
      selectedPaymentTab === "Finalized" ||
      // pay?.appointmentStatus === "completed" ||
      // pay?.status === "paid" ||
      // Number(totalAmt ?? 0) === Number(pay?.amtPaid ?? 0) ||
      pay?.type === "Pet Shop" || //for direct billing
      pay?.type === "Pharmacy" //for direct billing
    ) {
      // if (pay?.appointmentId) {
      //   dispatch(getCompliantSummaryByIdWoLoader(pay?.appointmentId));
      // }
      setSelectedBill(pay);
      return setInvModVisible(true);
    }
    if (
      pay?.appointmentStatus !== "completed" &&
      // pay?.status !== "paid" ||
      Number(totalAmt ?? 0) !== Number(pay?.amtPaid ?? 0)
    ) {
      return navigate("/clinic-pet-details", {
        state: {
          bill: pay,
          selectedTab: "billing",
          appointment: {
            appoinment: {
              appointmentId: pay?.appointmentId,
              petId: pay?.petId,
            },
          },
          editBill: true, //for landing to the bill directly
        },
      });
    }
  };

  const onGenerateBill = (itm) => {
    dispatch(
      enableCheckoutByAppointmentId({
        apntId: itm?.appointmentId,
        paymentId: itm?.paymentId,
        url: "?treatmentCheckout=Y&petShopCheckout=Y&pharmacyCheckout=Y",
      }),
    ).then((res) => {
      if (res?.payload) {
        onPaymentsApiCall();
      }
    });
  };

  const getTablePayments = (payments) => {
    // dispatch(showLoader());
    const requiredPayments = paymentsByFilter?.data?.map((pay, i) => {
      // const totalAmt = Number(
      //   roundWithSignedDiff(
      //     getTaxAndSubTotalAndTotalForTreatment(
      //       getTreatmentRecordBasedType(pay?.paymentDetails),
      //       services?.data,
      //       pay?.procedure ?? [],
      //     )?.subTotal,
      //   )?.rounded +
      //     roundWithSignedDiff(
      //       getTaxAndSubTotalAndTotal(
      //         getPharmacyRecordBasedType(pay?.paymentDetails),
      //       )?.subTotal,
      //     )?.rounded +
      //     roundWithSignedDiff(
      //       getTaxAndSubTotalAndTotal(
      //         getPetShopRecordBasedType(pay?.paymentDetails),
      //       )?.subTotal,
      //     )?.rounded,
      // );
      // const balDue = Number(Number(totalAmt ?? 0) - Number(pay?.amtPaid ?? 0));
      const totalAmt =
        (pay?.totalAmt ?? 0) +
        (pay?.pharmacyTotalAmt ?? 0) +
        (pay?.petShopTotalAmt ?? 0);
      const balDue =
        (pay?.balanceDue ?? 0) +
        (pay?.pharmacyBalanceDue ?? 0) +
        (pay?.petShopBalanceDue ?? 0);
      const totalAmtPaid =
        (pay?.amtPaid ?? 0) +
        (pay?.pharmacyAmtPaid ?? 0) +
        (pay?.petShopAmtPaid ?? 0);
      const isMainChecked = pay?.appointmentId
        ? ["Y"].includes(pay?.checkOut || pay?.checkout)
        : ["P", "Y"].includes(pay?.checkOut);
      const checked =
        isMainChecked ||
        pay?.pharmacyCheckout === "Y" ||
        pay?.petShopCheckout === "Y";
      const notFullyPaid = pay?.appointmentId
        ? ["unpaid", "partiallypaid"].includes(pay?.status) ||
          ["unpaid", "partiallypaid"].includes(pay?.pharmacyStatus) ||
          !pay?.pharmacyStatus ||
          ["unpaid", "partiallypaid"].includes(pay?.petShopStatus) ||
          !pay?.petShopStatus
        : ["unpaid", "partiallypaid"].includes(pay?.status);
      return {
        ...pay,
        payType:
          pay?.type === "Pharmacy" || pay?.type === "Pet Shop"
            ? pay?.type
            : "Clinic",
        petName: pay?.petName ?? pay?.userName,
        petImage: pay?.petImage,
        totalDue: Number(totalAmt) > 0 ? Number(totalAmt)?.toFixed(2) : "Nil",
        balanceDue: Number(balDue) > 0 ? Number(balDue)?.toFixed(2) : "Nil",
        trDate: moment(pay?.createdDate).format("DD MMM YYYY"),
        vetName: `${getRightSaluation(clinicVets, pay?.doctorId)}${
          pay?.doctorName
        }`,
        paymentStatus:
          Number(totalAmt ?? 0) === Number(totalAmtPaid ?? 0)
            ? "Paid"
            : Number(totalAmtPaid ?? 0) > 0
              ? "Partially Paid"
              : "Unpaid",
        gender: pay?.gender,
        breed: pay?.breed,
        pay: (
          <div className="flex-row-ali-cen">
            <Typography
              className="black9 gray-back5 fs12 font-bold ph10 pv5 br5 cursor mr10"
              onClick={() => onClickView(pay, totalAmt)}
            >
              View
            </Typography>
            {checked && notFullyPaid && balDue > 0 && (
              <Typography
                className="card-bot-green-back white-color fs12 font-bold ph10 pv5 br5 cursor mr10"
                onClick={() => {
                  createModalOpen(pay, balDue);
                }}
              >
                Pay
              </Typography>
            )}
            {pay?.appointmentId &&
              pay?.paymentId &&
              pay?.checkOut !== "Y" &&
              (pay?.appointmentStatus ?? "")?.toLowerCase() === "finalize" && (
                <Typography
                  className="blu-back white-color fs12 font-bold ph10 pv5 br5 cursor mr10"
                  onClick={() => onGenerateBill(pay)}
                >
                  Generate Bill
                </Typography>
              )}
            {pay?.type !== "Treatment" &&
              pay?.type !== "Pharmacy" &&
              pay?.type !== "Pet Shop" &&
              pay?.checkOut === "Y" &&
              pay?.pharmacyCheckout === "Y" &&
              pay?.petShopCheckout === "Y" &&
              pay?.paymentDetails?.some(
                (li) => !li?.returnQuantity || li?.returnQuantity === 0,
              ) && (
                // pay?.creditNote !== "Credit"
                <Typography
                  className="red5 red-back6 fs12 font-bold ph10 pv5 br5 cursor"
                  onClick={() => handleReturns(pay)}
                >
                  Return
                </Typography>
              )}
          </div>
        ),
        userName:
          pay?.type === "Pharmacy" || pay?.type === "Pet Shop"
            ? null
            : pay?.userName,
      };
    });
    // setTablePayments(requiredPayments);

    // dispatch(hideLoader());
    return requiredPayments;
  };

  const finalPayment = () => {
    //validation start
    let errs = {};
    if (
      !payValues?.amount ||
      isNaN(Number(payValues?.amount)) ||
      Number(payValues?.amount) <= 0 ||
      Number(payValues?.amount) > totalBalanceDue ||
      (payValues?.paymentMode?.value === "advanceAdjustment" &&
        Number(payValues?.amount) > Number(modalData?.advanceAmount))
    ) {
      errs = {
        ...errs,
        amount:
          payValues?.paymentMode?.value === "advanceAdjustment" &&
          Number(payValues?.amount) > Number(modalData?.advanceAmount)
            ? "Insufficient credit balance"
            : !payValues?.amount
              ? "This field is required"
              : Number(payValues?.amount) > totalBalanceDue
                ? "Amount must be less than or equal to balance due"
                : Number(payValues?.amount) <= 0
                  ? "Amount must be positive"
                  : "",
      };
    }

    if (Number(payValues?.amount) > totalBalanceDue) {
      errs = {
        ...errs,
        amount: "Amount must be less than or equal to balance due",
      };
    }

    if (!payValues?.paymentMode?.value) {
      errs = { ...errs, paymentMode: "This field is required" };
    }
    if (Object.values(errs).some((item) => item?.length > 0)) {
      return setPayErr(errs);
    }
    //validation end here
    const data = {
      paymentId: modalData.paymentId,
      paymentMode: payValues?.paymentMode?.value,
      paymentAmount: Number(payValues?.amount),
    };
    dispatch(updatePayment(data)).then(async (res) => {
      if (res?.payload) {
        onPaymentsApiCall(1);
        setPayModalVisible(false);
        setPayValues(initialValues);
        setTotalBalanceDue(0);
        handleInvModClose();
        setPayErr({});
        setModalData(null);
      }
    });
  };

  const handleInvModClose = () => {
    setPosPayId(null);
    setSelectedBill(null);
    setInvModVisible(false);
  };

  const handleChangePage = (e, selectedPage) => {
    onPaymentsApiCall(selectedPage);
  };

  const handleClosePayMod = (typ) => {
    if (typ === "apiSuccess") {
      onPaymentsApiCall(page);
    }
    setPayModalVisible(false);
    setModalData(null);

    // setPayValues(initialValues);
    // setTotalBalanceDue(0);
    // setPayErr({});
  };

  const onCloseRetMod = () => {
    setReturnModVsble(false);
    setSelectedBill(null);
  };

  const handleChange = (name, value) => {
    const reqObj = { ...returnValue, [name]: value };
    if (name === "isInvoiceSelected" && value) {
      const reqList = returnValue?.selectedInvoiceNumber?.includes("INVC")
        ? getTreatmentRecordBasedType(selectedBill?.paymentDetails)
        : returnValue?.selectedInvoiceNumber?.includes("INVP")
          ? getPharmacyRecordBasedType(selectedBill?.paymentDetails)
          : returnValue?.selectedInvoiceNumber?.includes("INVS")
            ? getPetShopRecordBasedType(selectedBill?.paymentDetails)
            : [];
      reqObj.list = reqList
        ?.filter(
          (li) =>
            li?.credit === "N" &&
            li?.type?.toLowerCase() !== "consumables" &&
            li?.type?.toLowerCase() !== "administered" &&
            li?.quantity > 0 &&
            (li?.returnQuantity === 0 || !li?.returnQuantity),
        )
        ?.map((li) => ({
          ...li,
          returnQuantity: 0,
        }));
    }
    setReturnValue(reqObj);
  };

  const handleChangeRetQty = (value, ind) => {
    const reqList = returnValue?.list?.map((li, i) => {
      if (i === ind) {
        const reqObj = {
          ...li,
          returnQuantity: value,
          returnQuantityErr:
            Number(li?.quantity) < Number(value) ? "Maximum limit reached" : "",
        };
        return reqObj;
      }
      return li;
    });
    const reqValue = { ...returnValue, list: reqList };
    if (listNotValid) {
      if (reqList?.some((li) => Number(li?.returnQuantity) > 0)) {
        setListNotValid(false);
      }
    }
    setReturnValue(reqValue);
  };

  const submitReturn = (status = "") => {
    const returnList = returnValue?.list?.filter(
      (li) => Number(li?.returnQuantity) > 0,
    );
    if (returnList?.length === 0 || !returnList) return setListNotValid(true);
    const paymentDetails = returnList?.map((li) => {
      const reqbj = {
        tax: isNaN(Number(Number(li?.tax) / Number(li?.quantity)))
          ? 0
          : Number(Number(li?.tax) / Number(li?.quantity)),
        price: li?.price,
        total: isNaN(Number(Number(li?.total) / Number(li?.quantity)))
          ? 0
          : Number(Number(li?.total) / Number(li?.quantity)),
        returnQuantity: Number(li?.returnQuantity),
        name: li?.name,
      };
      if (li?.serviceId) reqbj.serviceId = li?.serviceId;
      if (li?.stockId) reqbj.stockId = li?.stockId;
      if (li?.batchId) reqbj.batchId = li?.batchId;
      if (li?.paymentDetailId) reqbj.paymentDetailId = li?.paymentDetailId;
      return reqbj;
    });
    const data = {
      paymentMode: returnValue?.refundMethod?.value,
      personInCharge: returnValue?.personInCharge?.value ?? null,
      returnReason: returnValue?.returnReason?.value,
      paymentDetails,
      creditSave: status,
      remarks: returnValue?.remarks ?? "",
      invoiceNumbers: returnValue?.selectedInvoiceNumber,
    };
    dispatch(
      updateReturnOnBillingItems({ data, id: selectedBill?.paymentId }),
      // updateBillingItemsReturn({ data, id: selectedBill?.paymentId }),
    ).then((res) => {
      if (res?.payload) {
        onPaymentsApiCall(1);
        onCloseRetMod();
      }
    });
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    };
    setSearchValues(reqObj);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onPaymentsApiCall(1);
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = { ...initFilter, visible: true };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
    // if (filterValues?.selectedList?.length === 0) return;
    // onPaymentsApiCall(1);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({ ...initFilter, selectedList: [], values: {} });
    });
    onPaymentsApiCall(1, true);
  };

  const getPaymentMethodList = () => {
    return (
      paymentMethod?.list?.map((li) => ({
        name: li?.name,
        value: li?.name,
      })) ?? []
    );
  };

  const getClinicVetList = () => {
    return (
      clinicVets
        ?.filter((vl) => {
          if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
            return vl;
          }
        })
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.name, id: vet?.doctorId };
        }) ?? []
    );
  };

  const getBatch = (stkId = null, batchId = null) => {
    if (!stkId || !batchId) return null;
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stkId);
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const getInvoiceNumbers = () => {
    const reqList = [
      selectedBill?.invoiceNumbers ?? "",
      selectedBill?.treatmentInvoiceNumber ?? "",
      selectedBill?.petShopInvoiceNumber ?? "",
    ]?.filter(Boolean);
    return reqList?.map((li) => {
      const reqList = li?.includes("INVC")
        ? getTreatmentRecordBasedType(selectedBill?.paymentDetails)
        : li?.includes("INVP")
          ? getPharmacyRecordBasedType(selectedBill?.paymentDetails)
          : li?.includes("INVS")
            ? getPetShopRecordBasedType(selectedBill?.paymentDetails)
            : [];
      const reqAmtData = roundWithSignedDiff(
        getTaxAndSubTotalAndTotal(reqList)?.total,
      );
      return {
        name: `${li}, ₹${reqAmtData?.rounded}, ${moment(new Date(selectedBill?.createdDate)).format("DD MMM YYYY")}`,
        value: li,
      };
    });
  };

  const onTabChange = (tab) => {
    setSelectedPaymentTab(tab);
    setSearchValues(initSearch);
    onPaymentsApiCall(1, true, null, null, tab);
  };

  const getFieldName = (name, type) => {
    if (name === "Total Due") {
      if (type === "start") return "Min Total Due";
      return "Max Total Due";
    }
    if (name === "Balance Due") {
      if (type === "start") return "Min Balance Due";
      return "Max Balance Due";
    }
    if (name === "Transaction Date") {
      if (type === "start") return "Start Date";
      return "End Date";
    }
  };

  const onDownloadReport = () => {
    const todayDate = moment(new Date()).format("YYYY-MM-DD");
    const thirtyDaysAgo = moment(
      new Date(new Date().setDate(new Date().getDate() - 30)),
    ).format("YYYY-MM-DD");
    const url = `${baseURL}/clinic/payment/export-today-checkout-excel?startDate=${thirtyDaysAgo}&endDate=${todayDate}&clinicId=${clinicDet?.id}`;
    // `${baseURL}/clinic/payment/collection/download-daily?clinicId=${clinicDet?.id}&date=${reqDate}`;

    // /clinic/payment/export-today-checkout-excel?startDate=2026-04-01&endDate=2026-04-07&clinicId=2
    // /clinic/payment/export-today-checkout-excel?date=2026-04-01&clinicId=2
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="flex-row light-blue-back3 pv5">
        <Typography
          className={`ml20 newTab ph10 cursor ${selectedPaymentTab === "Pending" ? "newTabSelected blue-color" : ""}`}
          onClick={() => onTabChange("Pending")}
        >
          Open {/* Pending */}
        </Typography>
        <Typography
          className={`ml20 newTab ph10 cursor ${selectedPaymentTab === "Finalized" ? "newTabSelected blue-color" : ""}`}
          onClick={() => onTabChange("Finalized")}
        >
          Closed {/* Finalized */}
        </Typography>
        <Typography
          className={`ml20 newTab ph10 cursor ${selectedPaymentTab === "Collections" ? "newTabSelected blue-color" : ""}`}
          onClick={() => onTabChange("Collections")}
        >
          Collections
        </Typography>
      </div>
      {selectedPaymentTab === "Collections" ? (
        <CollectionsTable
          paymentTableType={paymentTableType}
          setPaymentTableType={setPaymentTableType}
        />
      ) : null}
      {selectedPaymentTab === "Finalized" ||
      selectedPaymentTab === "Pending" ? (
        <>
          <div className="flex-row mv10">
            <div className="top-row-cen-con w100Per">
              <div className="w15Per">
                <CustomTextField
                  placeholder="Pet Name"
                  fullWidth
                  name="petName"
                  handleChange={onSearchChange}
                  value={searchValues?.petName}
                  backgroundColor={AppColors.lightBlue2}
                  label="Pet Name"
                />
              </div>
              <div className="w15Per ml15">
                <CustomTextField
                  placeholder="User Name"
                  fullWidth
                  name="userName"
                  handleChange={onSearchChange}
                  value={searchValues?.userName}
                  backgroundColor={AppColors.lightBlue2}
                  label="User Name"
                />
              </div>
              {selectedPaymentTab === "Pending" ? (
                <div className="w15Per ml15">
                  <CustomTextField
                    placeholder="Vet Name"
                    fullWidth
                    name="vetName"
                    handleChange={onSearchChange}
                    value={searchValues?.vetName}
                    backgroundColor={AppColors.lightBlue2}
                    label="Vet Name"
                  />
                </div>
              ) : null}
              <div className="w15Per ml15">
                <CustomSelect
                  list={paymentSourceTypes}
                  value={searchValues?.source ?? []}
                  name="source"
                  handleChange={onSearchChange}
                  label="Source"
                  multiSelectSearchCheck
                  backgroundColor={AppColors.lightBlue2}
                />
              </div>
              {selectedPaymentTab === "Finalized" ? (
                <div className="w15Per ml15">
                  <CustomSelect
                    list={paymentStatusList}
                    value={searchValues?.status ?? []}
                    name="status"
                    handleChange={onSearchChange}
                    label="Status"
                    multiSelectSearchCheck
                    backgroundColor={AppColors.lightBlue2}
                  />
                </div>
              ) : null}
              {selectedPaymentTab === "Finalized" ? (
                <div
                  className="flex-row-ali-cen ml15 filter cursor"
                  onClick={() => onFilterChange("visible", true)}
                >
                  <TuneIcon sx={{ color: AppColors.appPrimary }} />
                  <Typography className="font-medium fs12 blue-color ml10">
                    {filterValues?.selectedList?.length > 0
                      ? `${filterValues?.selectedList?.length} `
                      : ""}
                    Filter
                  </Typography>
                </div>
              ) : null}
              <div className="ml15">
                <CustomButton text="Reset" onClick={onReset} smallBtn redBtn />
              </div>
              {selectedPaymentTab === "Finalized" ? (
                <div className="ml15">
                  <CustomButton text="⬇" onClick={onDownloadReport} smallBtn />
                </div>
              ) : null}
            </div>
          </div>
          <Typography className="font-medium fs12 gray28 ml30">
            Number of Records: {paymentsByFilter?.totalRecords ?? 0}
          </Typography>
          <div className="mtMin10">
            <Table
              columns={
                selectedPaymentTab === "Pending"
                  ? pendingTableHeaders
                  : tableHeaders
              }
              datas={getTablePayments()}
              onClickPay={() => {}}
              page={page}
              rowsPerPage={itemsPerLoad}
              grey
              totalRecords={paymentsByFilter?.totalRecords}
              handleChangePage={handleChangePage}
              maxHeight={400}
            />
          </div>
        </>
      ) : null}

      {invModVisible ? (
        <BillingPreview
          selectedBill={selectedBill}
          modVsble={invModVisible}
          onClosePreview={handleInvModClose}
          billsToShow={["treatment", "pharmacy", "petshop"]}
        />
      ) : null}

      {payModalVisible ? (
        <CommonPayModal
          modVsble={payModalVisible}
          selectedBill={modalData}
          billsToShow={["TREATMENT", "PHARMACY", "PETSHOP"]}
          onCloseMod={handleClosePayMod}
        />
      ) : null}

      {/* <CustomModal
        open={payModalVisible}
        onClose={handleClosePayMod}
        header="Pay"
        rightModal
        modalWidth={30}
      >
        <div className="flex-center">
          <Card
            sx={{
              borderRadius: 1,
              padding: 2,
              borderTopColor: `${getBorderColor(modalData?.status)}`,
            }}
            className="pay-card"
          >
            <div className="flex-row">
              <div className="w50Per">
                <Typography className="fs12 txt-semi-bold gray14">
                  Pet Name
                </Typography>
                <Typography className="fs14 txt-semi-bold black">
                  {modalData?.petName}
                </Typography>
              </div>
              <div className="w50Per">
                <Typography className="fs12 txt-semi-bold gray14">
                  Parent Name
                </Typography>
                <Typography className="fs14 txt-semi-bold black">
                  {modalData?.userName}
                </Typography>
              </div>
            </div>
            <div className="mh20Min">
              <div className="gry-hor-split3 mv5" />
            </div>
            <div className="mt10">
              <Typography className="txt-regular fs14 gray7">
                {moment(new Date(modalData?.createdDate)).format(
                  "DD MMM, YYYY",
                )}
              </Typography>
              <div className="bil-his-box mt5">
                <div className="flex-row">
                  <div className="flex-start">
                    <Typography className="fs14 font-medium black">
                      {modalData?.invoiceNumbers ??
                        modalData?.treatmentInvoiceNumber}
                    </Typography>
                  </div>
                  <div className="flex1-end">
                    <Typography className="txt-semi-bold fs14 orange3">
                      {Number(
                        Number(
                          roundWithSignedDiff(
                            getTaxAndSubTotalAndTotalForTreatment(
                              getTreatmentRecordBasedType(
                                modalData?.paymentDetails,
                              ),
                              services?.data,
                              modalData?.procedure ?? [],
                            )?.subTotal,
                          )?.rounded +
                            roundWithSignedDiff(
                              getTaxAndSubTotalAndTotal(
                                getPharmacyRecordBasedType(
                                  modalData?.paymentDetails,
                                ),
                              )?.subTotal,
                            )?.rounded +
                            roundWithSignedDiff(
                              getTaxAndSubTotalAndTotal(
                                getPetShopRecordBasedType(
                                  modalData?.paymentDetails,
                                ),
                              )?.subTotal,
                            )?.rounded,
                        ) - Number(modalData?.amtPaid ?? 0),
                      ) > 0
                        ? `Rs ${Number(
                            Number(
                              roundWithSignedDiff(
                                getTaxAndSubTotalAndTotalForTreatment(
                                  getTreatmentRecordBasedType(
                                    modalData?.paymentDetails,
                                  ),
                                  services?.data,
                                  modalData?.procedure ?? [],
                                )?.subTotal,
                              )?.rounded +
                                roundWithSignedDiff(
                                  getTaxAndSubTotalAndTotal(
                                    getPharmacyRecordBasedType(
                                      modalData?.paymentDetails,
                                    ),
                                  )?.subTotal,
                                )?.rounded +
                                roundWithSignedDiff(
                                  getTaxAndSubTotalAndTotal(
                                    getPetShopRecordBasedType(
                                      modalData?.paymentDetails,
                                    ),
                                  )?.subTotal,
                                )?.rounded,
                            ) - Number(modalData?.amtPaid ?? 0),
                          )?.toFixed(2)}`
                        : "Nil"}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            {modalData?.appointmentType ? (
              <div
                className={`conttype ${
                  modalData?.appointmentType === "Physical"
                    ? "card-con-blue-back"
                    : "virtual-bg-color"
                }`}
              >
                {modalData?.appointmentType}
              </div>
            ) : null}
          </Card>
        </div>
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <CustomTextField
              label="Amount"
              name="amount"
              fullWidth
              handleChange={(e) =>
                handleChangeValues("amount", e?.target?.value)
              }
              value={payValues?.amount}
              error={!!payErr?.amount}
              helperText={payErr?.amount}
              labelTop
              type="number"
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="font-medium fs14 black2">Payment Mode</div>
            <PaymentModeDropdown
              list={
                (profile?.id || profile?.createdBy) === RMVClinicId
                  ? RMVPaymentTypeList
                  : enabledPaymentTypes
              }
              value={payValues?.paymentMode}
              error={!!payErr?.paymentMode}
              helperText={payErr?.paymentMode}
              onChange={(e, value) => handleChangeValues("paymentMode", e)}
              name="paymentMode"
              label=""
            />
          </Grid>
          {payValues?.paymentMode?.value === "advanceAdjustment" ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="txt-semi-bold fs14 orange5">
                Available Balance:{" "}
                {Number(modalData?.advanceAmount) > 0
                  ? Number(modalData?.advanceAmount)?.toFixed(2)
                  : "-"}
              </Typography>
            </Grid>
          ) : null}
          <div className="flex1-end mt20">
            <div>
              <CustomButton text="Pay" onClick={finalPayment} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal> */}

      <CustomModal
        open={returnModVsble}
        onClose={onCloseRetMod}
        header={!returnValue?.isInvoiceSelected ? "Process Return" : ""}
        modal={returnValue?.isInvoiceSelected}
        modalWidth={!returnValue?.isInvoiceSelected ? 30 : 90}
        rightModal={!returnValue?.isInvoiceSelected}
      >
        {!returnValue?.isInvoiceSelected ? (
          <div className="scroll-80vh ph20">
            <div>
              <Typography className="font-medium fs14">Return Type</Typography>
              <CustomSelect selectFixed value="Sales" label="" />
            </div>
            <div className="mt10">
              <Typography className="font-medium fs14">
                Customer Name
              </Typography>
              <CustomSelect
                selectFixed
                value={selectedBill?.userName ?? ""}
                label=""
              />
            </div>
            <div className="mt10">
              <Typography className="font-medium fs14">
                Select Invoice
              </Typography>
              <CustomSelect
                select
                value={returnValue?.selectedInvoiceNumber ?? ""}
                label=""
                list={getInvoiceNumbers()}
                handleChange={(e) =>
                  handleChange("selectedInvoiceNumber", e?.target?.value)
                }
              />
            </div>
            <div className="flex1-end mt20">
              <div>
                <CustomButton
                  smallBtn
                  text="Next"
                  onClick={() => handleChange("isInvoiceSelected", true)}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="scroll-80vh">
            <div className="return-back">
              <div className="flex-row-ali-cen ph40 mv15">
                <div className="w25Per">
                  <Typography className="gray29 fs12 font-medium">
                    Pet Name
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {selectedBill?.petName ?? ""}
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="gray29 fs12 font-medium">
                    Parent Name
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {selectedBill?.userName ?? ""}
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="gray29 fs12 font-medium">
                    Invoice number
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {returnValue?.selectedInvoiceNumber}
                    {/* {[
                      selectedBill?.invoiceNumbers ?? "",
                      selectedBill?.treatmentInvoiceNumber ?? "",
                      selectedBill?.petShopInvoiceNumber ?? "",
                    ]
                      ?.filter(Boolean)
                      ?.join(", ")} */}
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="gray29 fs12 font-medium">
                    Invoice date
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {moment(new Date(selectedBill?.createdDate)).format(
                      "DD MMM YYYY",
                    )}
                  </Typography>
                </div>
              </div>
            </div>

            <div className="flex-row-ali-cen mt20 ph10">
              <div className="w25Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Service/Item Name
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Available Qty
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Returning Qty
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Unit Price
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Refundable Taxes
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Refund Total
                </Typography>
              </div>
            </div>
            <div className="blue-hor-split mt5" />
            {returnValue?.list?.map((li, i) => {
              const taxVal = Number(li?.tax) / Number(li?.quantity);
              return (
                <div className="plan-bor mt10 flex-row-ali-cen" key={`${i} li`}>
                  <div className="w25Per pr10">
                    <Custom3dotString
                      className="txt-regular fs12 gray30"
                      str={li?.name}
                      length={25}
                    />
                  </div>
                  <div className="w15Per pr10">
                    <Typography className="txt-regular fs12 gray30">
                      {li?.quantity} Nos
                    </Typography>
                  </div>
                  <div className="w15Per pr10">
                    <CustomTextField
                      value={li?.returnQuantity}
                      error={!!li?.returnQuantityErr}
                      helperText={li?.returnQuantityErr}
                      fullWidth
                      endIcon
                      inputIcon="Nos"
                      handleChange={(e) =>
                        handleChangeRetQty(e?.target?.value, i)
                      }
                    />
                  </div>
                  <div className="w15Per pr10">
                    <Typography className="txt-regular fs12 gray30">
                      Rs {Number(li?.mrpPrice)?.toFixed(2)}
                    </Typography>
                  </div>
                  <div className="w15Per pr10">
                    <Typography className="txt-regular fs12 gray30">
                      Rs {Number(taxVal) > 0 ? Number(taxVal)?.toFixed(2) : 0}
                    </Typography>
                  </div>
                  <div className="w15Per">
                    <Typography className="txt-regular fs12 gray30">
                      Rs{" "}
                      {Number(
                        Number(li?.returnQuantity ?? 0) *
                          Number(li?.mrpPrice ?? 0),
                      )?.toFixed(2)}{" "}
                    </Typography>
                  </div>
                </div>
              );
            })}
            {listNotValid ? (
              <FormHelperText error className="flex-center mt10">
                Enter quantity for atleast one item
              </FormHelperText>
            ) : null}
            <div className="flex-row mt30">
              <div className="w30Per">
                <div className="flex-column">
                  <CustomSelect
                    list={returnReasons}
                    value={returnValue?.returnReason}
                    handleChange={(e, value) =>
                      handleChange("returnReason", value)
                    }
                    search
                    fullWidth
                    label="Return Reason"
                    // labelTop
                    name="returnReason"
                  />
                  <div className="mt10">
                    <CustomSelect
                      list={getPersonInChargeList()}
                      value={returnValue?.personInCharge}
                      handleChange={(e, value) => {
                        handleChange("personInCharge", value);
                      }}
                      search
                      fullWidth
                      label="Person In charge"
                      name="personInCharge"
                    />
                  </div>
                  <div className="mt10">
                    <PaymentModeDropdown
                      list={RefundTypes}
                      value={returnValue?.refundMethod}
                      onChange={(e, value) => handleChange("refundMethod", e)}
                      name="refundMethod"
                      label="Refund Method"
                    />
                  </div>
                  <div className="mt10">
                    <CustomTextField
                      value={returnValue?.remarks}
                      handleChange={(e) =>
                        handleChange("remarks", e?.target?.value)
                      }
                      fullWidth
                      label="Remarks"
                      labelTop
                      name="remarks"
                      multiline
                    />
                  </div>
                </div>
              </div>
              <div className="flex1-end">
                <div className="w50Per">
                  <div className="flex-column">
                    <div className="flex-row-ali-cen">
                      <div className="w60Per">
                        <Typography className="black23 font-medium fs14">
                          Refund Subtotal
                        </Typography>
                      </div>
                      <div className="w40Per">
                        <Typography className="black23 font-medium fs14">
                          Rs.{" "}
                          {Number(
                            getRefundValues(returnValue?.list)?.subTotal,
                          )?.toFixed(2)}
                        </Typography>
                      </div>
                    </div>
                    <div className="flex-row-ali-cen mt10">
                      <div className="w60Per">
                        <Typography className="black23 font-medium fs14">
                          Refundable Taxes
                        </Typography>
                      </div>
                      <div className="w40Per">
                        <Typography className="black23 font-medium fs14">
                          Rs.{" "}
                          {Number(getRefundValues(returnValue?.list)?.tax) > 0
                            ? Number(
                                getRefundValues(returnValue?.list)?.tax,
                              )?.toFixed(2)
                            : 0}
                        </Typography>
                      </div>
                    </div>

                    <div className="flex-row-ali-cen ref-ttl mt30">
                      <div className="w60Per">
                        <Typography className="blue-color txt-semi-bold fs14">
                          Refund Total
                        </Typography>
                      </div>
                      <div className="w40Per">
                        <Typography className="blue-color font-bold fs14">
                          Rs.{" "}
                          {Number(
                            getRefundValues(returnValue?.list)?.total,
                          )?.toFixed(2)}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex1-end mt20">
              <div>
                <CustomButton
                  text="Save As Draft"
                  smallBtn
                  onClick={() => submitReturn("draft")}
                />
              </div>
              <div className="ml10">
                <CustomButton
                  text="Submit"
                  smallBtn
                  onClick={() => submitReturn("credit")}
                />
              </div>
            </div>
          </div>
        )}
      </CustomModal>

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        {dropFields?.includes(li) ? (
                          <CustomSelect
                            list={
                              li === "Invoice Type"
                                ? paymentInvoiceTypeList
                                : li === "Person In Charge"
                                  ? getClinicVetList()
                                  : li === "Payment Mode"
                                    ? getPaymentMethodList()
                                    : []
                            }
                            value={filterValues?.values?.[li] ?? []}
                            name={li}
                            handleChange={onFilterValuesChange}
                            label={li}
                            multiSelectSearchCheck={li !== "Person In Charge"}
                            select={li === "Person In Charge"}
                          />
                        ) : splitRows?.includes(li) ? (
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder={getFieldName(li, "start")}
                                fullWidth
                                name={getFieldName(li, "start")}
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.[
                                    getFieldName(li, "start")
                                  ]
                                }
                                type="number"
                                label={getFieldName(li, "start")}
                                mobileDate={li === "Transaction Date"}
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder={getFieldName(li, "end")}
                                fullWidth
                                name={getFieldName(li, "end")}
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.[
                                    getFieldName(li, "end")
                                  ]
                                }
                                type="number"
                                label={getFieldName(li, "end")}
                                mobileDate={li === "Transaction Date"}
                              />
                            </div>
                          </div>
                        ) : (
                          <CustomTextField
                            placeholder={li}
                            fullWidth
                            name={li}
                            handleChange={onFilterValuesChange}
                            value={filterValues?.values?.[li] ?? ""}
                            label={li}
                            suggetions
                            options={getSuggestionList()}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default Payments;
